import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import About from './pages/About';
import Calendar from './pages/Calendar';
import Families from './pages/Families';
import Gallery from './pages/Gallery';
import Home from './pages/Home';
import NoMatch from './pages/NoMatch';

const App = () => {
	return (
		<Routes>
			<Route path='/' element={<Home />} />
			<Route path='/about' element={<About />} />
			<Route path='/calendar' element={<Calendar />} />
			<Route path='/families' element={<Families />} />
			<Route path='/gallery' element={<Gallery />} />
			<Route path='*' element={<NoMatch />} />
		</Routes>
	);
};

export default App;
